"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const package_json_1 = __importDefault(require("./../package.json"));
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_config_1 = require("@App/configs/mobx-config");
const dayjs_config_1 = __importDefault(require("@App/configs/dayjs-config"));
const react_router_dom_1 = require("react-router-dom");
const routes_1 = __importDefault(require("@App/routes"));
const root_store_1 = __importDefault(require("@App/stores/root-store"));
const contexts_1 = require("@App/contexts");
const client_1 = require("react-dom/client");
const datadog_config_1 = require("@App/configs/datadog-config");
const configs_1 = require("@App/configs");
(0, mobx_config_1.configureMobX)();
(0, dayjs_config_1.default)();
const router = (0, routes_1.default)();
const rootStore = new root_store_1.default(router);
const container = document.getElementById('root');
const root = (0, client_1.createRoot)(container);
document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('CookiebotOnAccept', (e) => {
        if (Cookiebot.consent.statistics && configs_1.configuration.datadog_app_id) {
            (0, datadog_config_1.configureDatadog)();
        }
    });
});
(_a = module.hot) === null || _a === void 0 ? void 0 : _a.accept();
root.render(react_1.default.createElement(contexts_1.StoresContext.Provider, { value: rootStore },
    react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router })));
// eslint-disable-next-line no-console
console.log('FE-Version: ' + package_json_1.default.version);
